<template>
  <div class="flex flex-row gap-1">
    <a
      class="btn btn-primary btn-sm w-100"
      :href="link"
      rel="noopener noreferrer"
      target="_blank"
    >
      <slot />
      {{ !this.$slots.default ? (title || link ) : '' }}
    </a>
    <vx-tooltip text="Copiar enlace" placement="top">
      <b-button
        size="sm"
        variant="primary"
        @click="copyLink"
      >
        <feather-icon
          icon="ClipboardIcon"
          size="16"
          class="align-text-top"
        />
      </b-button>
    </vx-tooltip>
  </div>
</template>

<script>
import { showToast } from '@/febos/global/customDocuments/utils/showToast';

export default {
  name: 'link-button',
  props: {
    title: String,
    link: {
      type: String,
      required: true
    }
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.link).then(() => {
        showToast(this, 'Enlace copiado al portapapeles', '¡Genial!', {
          variant: 'success',
          autoHideDelay: 2000,
        });
      });
    }
  }
};
</script>
